import { MdOutlineHeadsetMic } from 'react-icons/md';
import { Chip, Image, Tooltip } from '@ds';
import { UnosIdButton } from '@ui';
import { DonorType, OrganType, ServiceType } from '@/api/apis/case';
import { getColorsByOrganType, getOrganImg } from '@/utils/helpers';
import styles from '../../CaseCard.module.scss';

type CardTitleProps = {
  organType: OrganType;
  donorType?: DonorType;
  color: string;
  dateLabel?: string;
  dateValue?: string | null;
  serviceType: ServiceType;
  donorId: string;
  caseSuffixes: string;
};

export const CardTitle = ({
  organType,
  caseSuffixes,
  donorType,
  color,
  dateLabel = 'Donor OR:',
  dateValue,
  serviceType,
  donorId,
}: CardTitleProps) => {
  const colors = getColorsByOrganType(organType);

  return (
    <div className="w-full">
      <div className="flex justify-between w-full items-center">
        <div className="flex items-center gap-1 flex-wrap">
          <UnosIdButton
            suffixColor={colors.textDefault}
            donorId={donorId}
            caseSuffixes={caseSuffixes}
            onDonorIdClick={(e) => e.stopPropagation()}
            containerClassName="text-[22px]"
          />
          <div className="flex items-center">
            <Chip className={`${styles.donorType} ${color}`}>{donorType ?? '-'}</Chip>
            <div className={`${styles.organIcon} ${color} rounded-full`}>
              <Image src={getOrganImg(organType)} alt={`${organType} image`} />
            </div>
            {serviceType === ServiceType.DirectAcquisition && (
              <Tooltip content="The ‘Direct Acquisition’ - purely for statistics purposes">
                <div className="ml-1 bg-warning-50 p-1 rounded-full">
                  <MdOutlineHeadsetMic aria-label="Direct Acquisition Icon" size={14} />
                </div>
              </Tooltip>
            )}
          </div>
        </div>
      </div>
      <div className="flex text-s-r gap-2 mt-2">
        <span className="truncate">{dateLabel}</span>
        <span className="text-s-sb truncate">{dateValue}</span>
        <span className="text-red font-semibold" />
      </div>
    </div>
  );
};
